import { Routes } from '@angular/router';
import { AuthGuard } from '@i7/shared';

export const recRoutes: Routes = [
  {
    path: 'cadastro-generico',
    loadChildren: () =>
      import(
        '../pages/cad/cadastro-generico/cadastro-generico.module'
      ).then((module) => module.CadastroGenericoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'recebimento-fisico',
    loadChildren: () =>
      import(
        '../pages/rec/recebimento-fisico/recebimento-fisico.module'
      ).then((module) => module.RecebimentoFisicoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'contrato',
    loadChildren: () =>
      import("../pages/cnt/contrato/contrato-routing.module").then(
        (module) => module.ContratoRoutingModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'tabela-preco',
    loadChildren: () =>
      import('../pages/cml/tabela-preco/tabela-preco.module').then(
        (module) => module.TabelaPrecoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'lista-preco',
    loadChildren: () =>
      import('../pages/cml/lista-preco/lista-preco.module').then(
        (module) => module.ListaPrecoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then(
        (module) => module.IndiceModule
      ),
    canActivate: [AuthGuard],
  }
];
